import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const searchPlatformViewAccessControl: DomainAccessControlConfig = {
  permissions: Permission.SearchPlatformView,
  warehouseFeatureToggles: [FeatureToggle.searchPlatform],
  // TODO: restore release gate before merging
  // minICPlatformVersion: ICPlatformVersion.r2026_03_0,
}

export const searchPlatformModifyAccessControl: DomainAccessControlConfig = {
  permissions: Permission.SearchPlatformModify,
  warehouseFeatureToggles: [FeatureToggle.searchPlatform],
  // TODO: restore release gate before merging
  // minICPlatformVersion: ICPlatformVersion.r2026_03_0,
}
